"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ReduxSdkActionTypes;

(function (ReduxSdkActionTypes) {
  ReduxSdkActionTypes["SetInitialized"] = "@archanova-sdk/SetInitialized";
  ReduxSdkActionTypes["SetConnected"] = "@archanova-sdk/SetConnected";
  ReduxSdkActionTypes["SetAccount"] = "@archanova-sdk/SetAccount";
  ReduxSdkActionTypes["SetAccountDevice"] = "@archanova-sdk/SetAccountDevice";
  ReduxSdkActionTypes["SetAccountFriendRecovery"] = "@archanova-sdk/SetAccountFriendRecovery";
  ReduxSdkActionTypes["SetDevice"] = "@archanova-sdk/SetDevice";
  ReduxSdkActionTypes["SetEns"] = "@archanova-sdk/SetEns";
  ReduxSdkActionTypes["SetEth"] = "@archanova-sdk/SetEth";
  ReduxSdkActionTypes["SetIncomingAction"] = "@archanova-sdk/SetIncomingAction";
  ReduxSdkActionTypes["SetAuthenticated"] = "@archanova-sdk/SetAuthenticated";
})(ReduxSdkActionTypes = exports.ReduxSdkActionTypes || (exports.ReduxSdkActionTypes = {}));